import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PedidosExternosService } from 'src/app/services/datos/pedidosExternos.service';

@Component({
  selector: 'app-panel-pedidos-pendientes',
  templateUrl: './panel-pedidos-pendientes.component.html',
  styleUrls: ['./panel-pedidos-pendientes.component.scss']
})
export class PanelPedidosPendientesComponent implements OnInit {

  // Emitir cuando haya datos
  @Output() tieneContenido = new EventEmitter<boolean>();

  pedidosPendientes: any = null;
  maxPedidos: number = 0;

  constructor(
    private pedidosExternosSrv: PedidosExternosService,) { }

  ngOnInit(): void {
    this.cargaPedidosPendientes();
  }


  cargaPedidosPendientes() {
    const opcionesList = {
      camp_cod_null: 1,
      soloTotales: 1,
      fecha_carga_null: 1,
    }
    this.pedidosExternosSrv.getLista(opcionesList).subscribe((resp) => {
      this.pedidosPendientes = resp.totales;
      console.log('__pedidosPendientes:', this.pedidosPendientes);

      this.preparaChartPedidos();

      // Si hay datos, emitir tieneContenido
      if (this.pedidosPendientes?.clientes?.length > 0) {
        this.tieneContenido.emit(true);
      }
    })
  }

  preparaChartPedidos() {
    if (!this.pedidosPendientes || !this.pedidosPendientes.clientes) {
      return;
    }

    // Ordenar por num_pedidos descendente
    this.pedidosPendientes.clientes.sort((a: any, b: any) => b.num_pedidos - a.num_pedidos);

    this.maxPedidos = Math.max(...this.pedidosPendientes.clientes.map((c: any) => c.num_pedidos));

    const colors = ['bg-primary', 'bg-info', 'bg-purple', 'bg-indigo', 'bg-pink', 'bg-cyan', 'bg-blue-grey'];
    this.pedidosPendientes.clientes = this.pedidosPendientes.clientes.map((c: any, index: number) => {
      return {
        ...c,
        colorClass: colors[index % colors.length]
      };
    });
  }


}
